module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left side-menu"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sidebar-inner slimscrollleft"
  }, [_c('div', {
    attrs: {
      "id": "sidebar-menu"
    }
  }, [_c('ul', [_vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "menu-title"
  }, [_vm._v("Businesses")]), _vm._v(" "), _c('li', {
    staticClass: "has_sub"
  }, [_c('a', {
    staticClass: "waves-effect",
    attrs: {
      "href": _vm.market.business_username
    }
  }, [_c('i', {
    staticClass: "mdi mdi-briefcase"
  }), _vm._v(" " + _vm._s(_vm.market.business_name))]), _vm._v(" "), _vm._l((_vm.market.business_markets), function(business) {
    return _c('a', {
      staticClass: "waves-effect",
      attrs: {
        "href": business.business_username
      }
    }, [_c('i', {
      staticClass: "mdi mdi-clipboard-outline"
    }), _vm._v(" " + _vm._s(business.business_name))])
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'CreateSellpoint',
        path: '/create/',
        params: {
          setUser: _vm.user
        }
      }
    }
  }, [_vm._v("Add a Business")])], 2), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "menu-title"
  }, [_vm._v("Reports")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('li', {
    staticClass: "menu-title"
  }, [_vm._v("Stocking")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('li', {
    staticClass: "menu-title"
  }, [_vm._v("Activites")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('li', {
    staticClass: "menu-title"
  }, [_vm._v("Help & Support")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topbar-left"
  }, [_c('div', {}, [_c('h3', [_vm._v("STANEL")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "has_sub"
  }, [_c('a', {
    staticClass: "waves-effect",
    attrs: {
      "href": "dashboard"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-view-dashboard"
  }), _vm._v(" "), _c('span', [_vm._v(" Dashboard \r\n                            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "waves-effect",
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-airplane"
  }), _c('span', [_vm._v("Visit Main Site")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "waves-effect",
    attrs: {
      "href": "/payments"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-file-document-box"
  }), _c('span', [_vm._v(" Payments ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "waves-effect",
    attrs: {
      "href": "/orders"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-file-document-box"
  }), _c('span', [_vm._v(" Orders ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "waves-effect",
    attrs: {
      "href": "/stocks"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-file-document-box"
  }), _c('span', [_vm._v(" Stock Management ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "waves-effect",
    attrs: {
      "href": "/inventory"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-file-document-box"
  }), _c('span', [_vm._v(" Inventory ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "waves-effect",
    attrs: {
      "href": "/events"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-file-document-box"
  }), _c('span', [_vm._v(" Events ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "waves-effect",
    attrs: {
      "href": "/posts"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-file-document-box"
  }), _c('span', [_vm._v(" Blog Posts ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "waves-effect",
    attrs: {
      "href": "/settings"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-headset"
  }), _c('span', [_vm._v(" Settings ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "waves-effect",
    attrs: {
      "href": "/documentation"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-file-document-box"
  }), _c('span', [_vm._v(" Documentation ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "waves-effect",
    attrs: {
      "href": "/controlpanel"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-clipboard-outline"
  }), _c('span', [_vm._v("Radar Control Panel ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c690081c"}!./src/pages/MainSidebar/template.html
// module id = 309
// module chunks = 0